import classNames from "classnames";
import React from "react";
import styles from "./../../../ricos-common-plugins/gap-spacer/gap-spacer-component/gap-spacer-styles-scss.js";
const GapSpacer = ({
  collapsed,
  betweenFloated,
  needsTopMargin
}) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-hook": "gap-spacer",
      ...needsTopMargin ? { "data-gap-spacer-top-margin": "" } : {},
      className: classNames(styles.gapSpacerViewer, {
        [styles.collapsed]: collapsed,
        [styles.betweenFloated]: betweenFloated
      })
    }
  );
};
export {
  GapSpacer
};
//# sourceMappingURL=gap-spacer.js.map
